export const getAssociationDisplayLabel = (value?: string | null) => {
  const normalized = String(value || "").trim().toLowerCase()

  if (normalized === "inhouse") return "Onrole"
  if (normalized === "vendor") return "Offrole"

  return value || "N/A"
}
